import React from "react";
import "./SuccessModal.css";

export default function SuccessModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-icon">✓</div>
        <h2>Order Submitted Successfully!</h2>
        <p>Thank you for your interest in Siddhi Wig.</p>
        <p className="modal-detail">
          Your details have been submitted successfully. Our team will contact
          you soon at the provided phone number.
        </p>
        <button onClick={onClose} className="modal-button">
          Continue Shopping
        </button>
      </div>
    </div>
  );
}
